module.exports = __webpack_public_path__ + "media/images/svg/report-441383971d7671eb4d5331f3bb05ba0a.svg";